var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cta btn",class:_vm.classes,on:{"click":function($event){return _vm.emitBtnClick()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }